export default __webpack_public_path__ + "static/media/twitter-svgrepo-com.5229b35a.svg";